import {create} from 'zustand';
import dayjs, {Dayjs} from 'dayjs';

export interface CheckResultFilterState {
    jobId?: number;
    groupKey?: string;
    status?: number;
    resultCode?: number;
    createTimeRange?: [Dayjs | null, Dayjs | null] | null;
}

export const defaultCheckResultFilters = (): CheckResultFilterState => ({
    createTimeRange: [dayjs().startOf('day'), dayjs().endOf('day')],
});

export const serializeCheckResultFilters = (f: CheckResultFilterState): string =>
    JSON.stringify({
        jobId: f.jobId ?? null,
        groupKey: f.groupKey ?? null,
        status: f.status ?? null,
        resultCode: f.resultCode ?? null,
        createTimeFrom: f.createTimeRange?.[0]?.valueOf() ?? null,
        createTimeTo: f.createTimeRange?.[1]?.valueOf() ?? null,
    });

interface BcpCheckResultListState {
    tempFilters: CheckResultFilterState;
    filters: CheckResultFilterState;
    currentPage: number;
    pageSize: number;
    needRefetch: boolean;
    setTempFilters: (filters: CheckResultFilterState) => void;
    applyFilters: () => void;
    resetFilters: () => void;
    setPage: (page: number, size: number) => void;
    markNeedRefetch: () => void;
    clearNeedRefetch: () => void;
}

export const useBcpCheckResultListStore = create<BcpCheckResultListState>()((set) => ({
    tempFilters: defaultCheckResultFilters(),
    filters: defaultCheckResultFilters(),
    currentPage: 1,
    pageSize: 10,
    needRefetch: false,
    setTempFilters: (filters) => set({tempFilters: filters}),
    applyFilters: () => set((s) => ({filters: {...s.tempFilters}, currentPage: 1})),
    resetFilters: () =>
        set({
            tempFilters: defaultCheckResultFilters(),
            filters: defaultCheckResultFilters(),
            currentPage: 1,
        }),
    setPage: (page, size) => set({currentPage: page, pageSize: size}),
    markNeedRefetch: () => set({needRefetch: true}),
    clearNeedRefetch: () => set({needRefetch: false}),
}));
